$('.SizeSwatch.no').click(function(){
$('.ProductForm__AddToCart').hide();
});
$('.SizeSwatch.yes').click(function(){
$('.ProductForm__AddToCart').show();
});

$('.cz_dropdown-toggle-bar').click(function(){
$('.cz_dropdown-menu-bar').toggleClass('cz_show');
});

/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*
* You can also add a listener whenever a product is added to the cart:
*
* document.addEventListener('product:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
*   var quantity = event.detail.quantity; // Get the quantity that was added
* });
*
* If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
* "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
*
* document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
*   bubbles: true
* }));
*/

//
//   Variables
//
//////////////////////////////////////////////////////////////////////

// Play with this value to change the speed
let tickerSpeed = 0.5;
let flickity = null;
let isPaused = false;
const slideshowEl = document.querySelector('.featured_collection_slider');
const slideshowEl1 = document.querySelector('.image_slider_collection');

//
//   Functions
//
//////////////////////////////////////////////////////////////////////

const update = () => {
if (isPaused) return;
if (flickity.slides) {
flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
flickity.selectedIndex = flickity.dragEndRestingSelect();
flickity.updateSelectedSlide();
flickity.settle(flickity.x);
}
window.requestAnimationFrame(update);
};

const pause = () => {
isPaused = true;
};

const play = () => {
if (isPaused) {
isPaused = false;
window.requestAnimationFrame(update);
}
};


//
//   Create Flickity
//
//////////////////////////////////////////////////////////////////////

flickity = new Flickity(slideshowEl, {
autoPlay: false,
prevNextButtons: true,
pageDots: false,
draggable: true,
wrapAround: true,
selectedAttraction: 0.015,
friction: 0.25,
arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
});
flickity = new Flickity(slideshowEl1, {
autoPlay: false,
prevNextButtons: true,
pageDots: false,
draggable: true,
wrapAround: true,
selectedAttraction: 0.015,
friction: 0.25,
arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
});
flickity.x = 0;


//
//   Add Event Listeners
//
//////////////////////////////////////////////////////////////////////

slideshowEl.addEventListener('mouseenter', pause, false);
slideshowEl.addEventListener('focusin', pause, false);
slideshowEl.addEventListener('mouseleave', play, false);
slideshowEl.addEventListener('focusout', play, false);

slideshowEl1.addEventListener('mouseenter', pause, false);
slideshowEl1.addEventListener('focusin', pause, false);
slideshowEl1.addEventListener('mouseleave', play, false);
slideshowEl1.addEventListener('focusout', play, false);

flickity.on('dragStart', () => {
isPaused = true;
});

update();




$(document).ready(function () {
/* $.ajax({
url: "https://geolocation-db.com/jsonp",
jsonpCallback: "callback",
dataType: "jsonp",
success: function( location ) {
alert(location.country_name);
if(location.country_name == 'United States'){
$('body').addClass('us_location');
}
else{
$('body').removeClass('us_location');
}
}
});*/

/*var country_name = '';    
_ipgeolocation.makeAsyncCallsToAPI(false);
_ipgeolocation.getGeolocation(handleResponse, "ee9d64c116d04d8dbbf641d26d908b38");
function handleResponse(json) {
country_name = json.country_name;
}
  console.log(country_name);
if(country_name == 'United States'){
$('body').addClass('us_location');
//window.location.href = "https://us-jkattire.com/";
}
else{
$('body').removeClass('us_location');
}*/

});